import {IAddInquires} from "../../types";
export const inquiresJSON = {
    addInquires: ({firstName, lastName, agencyName, email}: IAddInquires) => {
        return {
            firstName,
            lastName,
            agencyName,
            email: email,
        };
    },
};
